import { makeStyles } from "@material-ui/core";
import StandardModal from "./StandardModal";

type StandardModalTermoAceiteProps = {
  showModal: boolean;
  onCloseModal: () => void;
};

const stylesTermoAceite = makeStyles({
  titulo: {
    fontSize: "1vw",
    color: "#2F4050",
    fontWeight: "bold",
    marginTop: "1.5vh",
  },
  paragrafo: {
    fontSize: "0.85vw",
    color: "#2F4050",
    marginBottom: "1vh",
  },
  listaItem: {
    fontSize: "0.85vw",
    color: "#2F4050",
    marginLeft: "2vw",
    marginBottom: "0.5vh",
  },
  textoDestaque: {
    fontSize: "0.85vw",
    fontWeight: "bold",
    color: "#2F4050",
  },
  textoVersao: {
    textAlign: "right",
    fontWeight: "bold",
  },
});

const StandardModalTermoAceite: React.FC<StandardModalTermoAceiteProps> = ({ showModal, onCloseModal }) => {
  const styles = stylesTermoAceite();

  const TituloSecao = ({ children }: { children: React.ReactNode }) => <p className={styles.titulo}>{children}</p>;

  const Paragrafo = ({ children }: { children: React.ReactNode }) => <p className={styles.paragrafo}>{children}</p>;

  const ListaItem = ({ children }: { children: React.ReactNode }) => <li className={styles.listaItem}>{children}</li>;

  const TextoDestaque = ({ children }: { children: React.ReactNode }) => (
    <span className={styles.textoDestaque}>{children}</span>
  );

  return (
    <StandardModal
      showModal={showModal}
      scrollable={true}
      onCloseModal={onCloseModal}
      topBar="Termo de aceite"
      titulo="TERMO DE ACEITE PARA ACESSO A CAIXA DE E-MAIL VIA PROTOCOLO IMAP – GROUP PAY"
      tituloStyle={{ fontSize: "1vw", fontWeight: "bold", color: "#2F4050", textAlign: "center" }}
      conteudoPrimario={
        <>
          <Paragrafo>
            <p className={styles.textoVersao}>Versão 1.0 - 14 de agosto de 2025</p>
          </Paragrafo>
          <Paragrafo>
            Pelo presente Instrumento ("Termo de Aceite"), o(a) <TextoDestaque>CONTRATANTE</TextoDestaque>, pessoa
            física ou pessoa jurídica (doravante denominado(a) "<TextoDestaque>CLIENTE</TextoDestaque>"), que aderiu às
            condições comerciais constantes em Pedido de Licença Temporária do Direito de Uso do Software{" "}
            <TextoDestaque>GROUP PAY</TextoDestaque>, licenciado pela <TextoDestaque>GROUP SOFTWARE LTDA</TextoDestaque>
            . Inscrita no CNPJ/MF sob o nº 01.413.092/0001-02, com sede na Rua Santa Catarina, nº 1.631, 5º andar,
            Lourdes, Belo Horizonte, Minas Gerais, CEP: 30.170-080 (doravante denominada "
            <TextoDestaque>GROUP SOFTWARE</TextoDestaque>"), autoriza, de forme expressa, a{" "}
            <TextoDestaque>GROUP SOFTWARE</TextoDestaque> a acessar sua caixa de e-mail, por meio do protocolo IMAP,
            exclusivamente para viabilizar a funcionalidade do <TextoDestaque>GROUP PAY</TextoDestaque> de localizar e
            capturar notas fiscais e documentos relacionados a despesas, com a finalidade única de integração nos ERPs
            da GROUP SOFTWARE (<TextoDestaque>Group Condomínios</TextoDestaque> e/ou{" "}
            <TextoDestaque>Condomínio21</TextoDestaque>). Ao aderir, o(a) <TextoDestaque>CLIENTE</TextoDestaque> declara
            aceitar, de forma plena e sem reservas, todos os termos e condições expostos a seguir.
          </Paragrafo>
        </>
      }
      conteudoPrimarioStyle={{ marginBottom: "0.85vh", fontSize: "0.85vw" }}
      conteudoSecundario={
        <>
          <TituloSecao>1. OBJETO</TituloSecao>
          <Paragrafo>
            1.1. O presente Termo de Aceite tem por objeto regular o consentimento expresso, livre e inequívoco do(a)
            <TextoDestaque> CLIENTE</TextoDestaque> para que a <TextoDestaque>GROUP SOFTWARE</TextoDestaque>, por meio
            do software <TextoDestaque>GROUP PAY</TextoDestaque>, acesse diretamente a caixa de entrada de e-mails
            indicada pelo(a) <TextoDestaque>CLIENTE</TextoDestaque>, via protocolo IMAP (Internet Message Access
            Protocol), com a finalidade exclusiva de identificar automaticamente e-mails que contenham notas fiscais,
            boletos ou outros documentos relacionados a despesas, visando à integração com os sistemas ERPs Group
            Condomínios e/ou Condomínio21, ambos integrantes do portifólio de produtos da{" "}
            <TextoDestaque>GROUP SOFTWARE</TextoDestaque>.
          </Paragrafo>
          <TituloSecao>2. DEFINIÇÃO DE IMAP (INTERNET MESSAGE ACCESS PROTOCOL)</TituloSecao>
          <Paragrafo>
            2.1. IMAP (Internet Message Access Protocol) é um protocolo padrão amplamente utilizado no mercado para
            acesso às mensagens de e-mails de diferentes dispositivos, que permite mantê-las armazenadas no servidor com
            todas as alterações devidamente sincronizadas em todos os dispositivos conectados.
          </Paragrafo>
          <TituloSecao>3. FINALIDADE E LIMITAÇÃO DO ACESSO</TituloSecao>
          <Paragrafo>
            3.1. O acesso da <TextoDestaque>GROUP SOFTWARE</TextoDestaque> à caixa de e-mail do(a){" "}
            <TextoDestaque>CLIENTE</TextoDestaque> será realizado de forma automatizada, utilizando tecnologia própria
            para identificar padrões que caracterizem e-mails contendo documentos fiscais (notas fiscais), boletos e
            documentos correlatos a despesas.
          </Paragrafo>
          <Paragrafo>
            3.2. A finalidade específica do acesso é a coleta dos documentos de despesas estritamente necessários para a
            integração aos sistemas ERPs do(a) <TextoDestaque>CLIENTE</TextoDestaque> (
            <TextoDestaque>Group Condomínios</TextoDestaque> ou <TextoDestaque>Condomínio21</TextoDestaque>, conforme o
            caso).
          </Paragrafo>
          <Paragrafo>
            3.3. A <TextoDestaque>GROUP SOFTWARE</TextoDestaque> declara e o(a) <TextoDestaque>CLIENTE</TextoDestaque>{" "}
            tem ciência e concorda que:
          </Paragrafo>
          <ul>
            <ListaItem>
              fornecerá à <TextoDestaque>GROUP SOFTWARE</TextoDestaque> todas as credenciais de acesso, declarando, para
              todos os fins de direito, possuir plenos poderes para conceder tais informações;
            </ListaItem>
            <ListaItem>
              deverá notificar imediatamente a <TextoDestaque>GROUP SOFTWARE</TextoDestaque> sobre qualquer alteração
              nas credenciais de acesso ou qualquer suspeita de uso não autorizado;
            </ListaItem>
            <ListaItem>
              o acesso à caixa de e-mail ocorrerá em sua totalidade, em razão de características técnicas inerentes ao
              protocolo IMAP, que permite o acesso a todos os e-mails nela armazenados;
            </ListaItem>
            <ListaItem>
              não obstante o acesso total, a <TextoDestaque>GROUP SOFTWARE</TextoDestaque> se compromete a processar e
              extrair apenas os dados relacionados a notas fiscais, boletos e documentos vinculados a despesas,
              ignorando, descartando e não armazenando quaisquer outras informações de caráter pessoal ou não, contidas
              em e-mails que não se enquadrem na finalidade descrita neste Termo de Aceite;
            </ListaItem>
            <ListaItem>
              a <TextoDestaque>GROUP SOFTWARE</TextoDestaque> não enviará, excluirá e/ou alterará mensagens,
              limitando-se à leitura e captura dos documentos estritamente necessários para a finalidade descrita neste
              Termo de Aceite;
            </ListaItem>
            <ListaItem>
              a tecnologia de leitura empregada visa garantir que apenas os documentos pertinentes à finalidade exposta
              neste Termo de Aceite sejam selecionados para integração com os ERPs da{" "}
              <TextoDestaque>GROUP SOFTWARE</TextoDestaque>, protegendo a privacidade de outras comunicações do(a){" "}
              <TextoDestaque>CLIENTE</TextoDestaque>;
            </ListaItem>
            <ListaItem>
              o(a) <TextoDestaque>CLIENTE</TextoDestaque> poderá, quando tecnicamente possível, restringir o escopo de
              acesso à sua caixa de e-mail, ciente de que tais limitações poderão comprometer, parcial ou totalmente, a
              captura integral e adequada dos documentos, bem como a plena funcionalidade do{" "}
              <TextoDestaque>GROUP PAY</TextoDestaque>.
            </ListaItem>
          </ul>
          <TituloSecao>4. SEGURANÇA E CONFIDENCIALIDADE</TituloSecao>
          <Paragrafo>
            4.1 A GROUP SOFTWARE se compromete a empregar os melhores esforços, bem como adotar medidas técnicas,
            administrativas e organizacionais adequadas de segurança da informação, para proteger os dados acessados e
            processados, a fim de garantir a confidencialidade, integridade e disponibilidade das informações, em
            conformidade com a legislação aplicável, em especial a Lei Geral de Proteção de Dados Pessoais (Lei nº
            13.709/2018 - LGPD).
          </Paragrafo>
          <Paragrafo>
            4.2. A <TextoDestaque>GROUP SOFTWARE</TextoDestaque> manterá sigilo absoluto sobre todas e quaisquer
            informações não relacionadas à finalidade do presente Termo que eventualmente sejam acessadas durante o
            processo de leitura da caixa de e-mail, comprometendo-se a não as divulgar, transferir ou utilizar para
            quaisquer outras finalidades.
          </Paragrafo>
          <Paragrafo>
            4.3. A operação de acesso à caixa de e-mail do(a) <TextoDestaque>CLIENTE</TextoDestaque> será desempenhada
            pela <TextoDestaque>GROUP SOFTWARE</TextoDestaque> dentro das diretrizes e possibilidades técnicas
            aplicáveis. Entretanto, o(a) <TextoDestaque>CLIENTE</TextoDestaque> reconhece que nenhum sistema, servidor
            ou software está absolutamente imune a vícios, defeitos, erros, ataques e/ou invasões de hackers ou qualquer
            outra intrusão de segurança, de modo que a <TextoDestaque>GROUP SOFTWARE</TextoDestaque> renuncia a toda e
            qualquer responsabilidade perante o(a) <TextoDestaque>CLIENTE</TextoDestaque> por qualquer perda ou dano
            relacionados de qualquer forma à exclusão, obtenção, utilização ou divulgação não autorizada de informações
            contidas no e-mail cujo acesso foi liberado para a funcionalidade do{" "}
            <TextoDestaque>GROUP PAY</TextoDestaque>.
          </Paragrafo>
          <TituloSecao>5. TRATAMENTO DE DADOS PESSOAIS</TituloSecao>
          <Paragrafo>
            5.1. O(A) <TextoDestaque>CLIENTE</TextoDestaque> entende e concorda que, de acordo com as definições
            estabelecidas na LGPD, possui papel de CONTROLADOR dos dados pessoais contidos na caixa de e-mail indicada e
            que a <TextoDestaque>GROUP SOFTWARE</TextoDestaque> atua como OPERADORA, realizando o tratamento
            exclusivamente para os fins descritos neste Termo.
          </Paragrafo>
          <Paragrafo>
            5.2. O presente Termo de Aceite não transfere a propriedade de quaisquer dados do(a){" "}
            <TextoDestaque>CLIENTE</TextoDestaque> para a <TextoDestaque>GROUP SOFTWARE</TextoDestaque>.
          </Paragrafo>
          <Paragrafo>
            5.3 Todas as solicitações referentes à LGPD, direcionadas à <TextoDestaque>GROUP SOFTWARE</TextoDestaque>,
            devem ser formuladas por meio do link www.groupsoftware.com.br/lgpd, sendo este o único e exclusivo canal
            para tratamento e encaminhamento de demandas desta natureza.
          </Paragrafo>
          <TituloSecao>6. CONSENTIMENTO E REVOGAÇÃO</TituloSecao>
          <Paragrafo>
            6.1 O(A) <TextoDestaque>CLIENTE</TextoDestaque>, ao aceitar o presente Termo, declara que:
          </Paragrafo>
          <ul>
            <ListaItem>
              foi devidamente informado sobre a natureza do acesso à sua caixa de e-mail (via protocolo IMAP);
            </ListaItem>
            <ListaItem>
              está ciente dos riscos inerentes à concessão de acesso a terceiros à sua caixa de e-mail, ainda que para
              fins específicos e com as devidas garantias de segurança e privacidade previstas neste Termo;
            </ListaItem>
            <ListaItem>
              concede, de forma livre, informada, expressa e inequívoca, seu consentimento para o acesso e tratamento
              dos dados de sua caixa de e-mail pela <TextoDestaque>GROUP SOFTWARE</TextoDestaque>, nos termos e para os
              fins aqui estabelecidos.
            </ListaItem>
          </ul>
          <Paragrafo>
            6.2. A habilitação ou desabilitação da opção de acesso à caixa de e-mail é de inteira responsabilidade do(a)
            <TextoDestaque> CLIENTE</TextoDestaque>, que deverá realizar essa configuração diretamente no sistema,
            estando ciente de que tal decisão impactará o funcionamento da funcionalidade de busca automatizada de notas
            fiscais e boletos por meio do
            <TextoDestaque> GROUP PAY</TextoDestaque>.
          </Paragrafo>
          <Paragrafo>
            6.3. O presente consentimento é válido e eficaz enquanto o(a) <TextoDestaque>CLIENTE</TextoDestaque>{" "}
            utilizar a opção de acesso à caixa de e-mail via protocolo IMAP na funcionalidade do{" "}
            <TextoDestaque>GROUP PAY</TextoDestaque>.
          </Paragrafo>
          <Paragrafo>
            6.4. O(A) <TextoDestaque>CLIENTE</TextoDestaque> poderá revogar seu consentimento a qualquer tempo,
            diretamente no sistema, por meio da opção de desabilitar o acesso à caixa de e-mail. A revogação do
            consentimento pelo(a) <TextoDestaque>CLIENTE</TextoDestaque> implicará na interrupção do acesso à caixa de
            e-mail e da funcionalidade de busca automatizada de notas fiscais e boletos por meio do{" "}
            <TextoDestaque>GROUP PAY</TextoDestaque>.
          </Paragrafo>
          <TituloSecao>7. DISPOSIÇÕES GERAIS</TituloSecao>
          <Paragrafo>
            7.1. A <TextoDestaque>GROUP SOFTWARE</TextoDestaque> se reserva no direito de promover alterações nas
            disposições do presente Termo a qualquer tempo para fins de atualização e melhoria na prestação dos
            serviços. O(a) <TextoDestaque>CLIENTE</TextoDestaque> será informado sobre as modificações efetuadas por
            meio do próprio ambiente do software.
          </Paragrafo>
          <Paragrafo>
            7.2. Todas as alterações entrarão em vigor imediatamente após serem postadas no software. A continuidade da
            utilização dos serviços significa que o(a) <TextoDestaque>CLIENTE</TextoDestaque> aceita estes Termos e
            quaisquer alterações nos mesmos.
          </Paragrafo>
          <Paragrafo>
            7.3. Todas as cláusulas e condições previstas no Contrato de Licença do Direito de Uso do Software firmado
            entre o(a) <TextoDestaque>CLIENTE</TextoDestaque> e a <TextoDestaque>GROUP SOFTWARE</TextoDestaque> seguem
            totalmente inalteradas e ratificadas, permanecendo em pleno vigor.
          </Paragrafo>
          <Paragrafo>7.4. O foro para dirimir quaisquer controvérsias será o do contrato primitivo.</Paragrafo>
          <Paragrafo>
            7.5. Este Termo será regido e interpretado de acordo com as leis da República Federativa do Brasil.
          </Paragrafo>
        </>
      }
      size="lg"
      fecharModalAoClicarFora={true}
      containerStyle={{ margin: 0, paddingLeft: "1vw", textAlign: "left" }}
      footer={null}
    />
  );
};

export default StandardModalTermoAceite;
